import { render, staticRenderFns } from "./xiaoshou.vue?vue&type=template&id=8295be8c"
import script from "./xiaoshou.vue?vue&type=script&lang=js"
export * from "./xiaoshou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports